// tslint:disable:jsx-no-multiline-js (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import * as React from 'react';
import Radium from '../../../styling/rostelecom-radium';
import Color from 'color';
import InternationalizedComponent from '../../../../../base/internationalized-component';
import { IRostelecomStyleParamsStoreState } from '../../../styling/rostelecom-styles-store';
import Indicator from './indicator';
import { IReactRadiumFreeStyles } from '../../../../../base/radium-types';

export interface ILoginInputProps extends React.Props<LoginPasswordInput> {
    styleParams: IRostelecomStyleParamsStoreState;
    formProps: IFormComponentProps;
    disabled?: boolean;
    type?: string;
}

export interface IPasswordInputState {
    isCapsLockOn?: any;
    inputLang: string;
}

@Radium
class LoginPasswordInput extends InternationalizedComponent<ILoginInputProps, IPasswordInputState> {
    // tslint:disable-next-line:typedef (autogenerated)
    constructor(props, opts) {
        super(props, opts);

        this.keyDownHandler = this.keyDownHandler.bind(this);
    }

    // tslint:disable-next-line:typedef member-access (autogenerated)
    componentWillMount() {
        this.setState({
            isCapsLockOn: false,
            inputLang: ''
        });
    }

    private getStyles(): IReactRadiumFreeStyles {
        const styleParams = this.props.styleParams;
        return {
            fieldOuter: {
                position: 'relative',
                textAlign: 'left'
            },
            label: {
                display: 'block',
                fontSize: '14px',
                marginTop: 0,
                marginBottom: 6,
                color: Color(styleParams.neutralColor)
                    .darken(0.6)
                    .hexString()
            },
            passwordContainer: {
                position: 'relative',
                width: '100%',
                lineHeight: '32px',
                fontSize: '16px',
                height: 32,
                border: '1px solid ' + styleParams.neutralColor,
                borderRadius: '3px',
                textAlign: 'right',
                padding: '0px 3px'
            },
            input: {
                display: 'inline-block',
                width: '100%',
                lineHeight: '30px',
                height: 28,
                border: 'none',
                borderRadius: '3px',
                zIndex: 1,
                float: 'left',
                paddingTop: '4px',
                ':focus': {
                    outline: 'none'
                }
            },
            validationError: {
                display: 'block',
                color: styleParams.baseAccentColor,
                minHeight: 20,
                lineHeight: '20px',
                fontSize: '12px'
            },
            indicatorContainer: {
                position: 'absolute',
                top: 0,
                right: 0,
                padding: '3px',
                zIndex: 10
            }
        };
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    prepareInputProps(props: IFormComponentProps) {
        const { id, onChange, onBlur, onFocus } = props;
        return {
            id,
            onBlur,
            onFocus,
            onChange: evt => {
                onChange(evt.target.value);
            }
        };
    }

    // tslint:disable-next-line:typedef (autogenerated)
    private isCapsLockOn(event): boolean {
        if (event.key === 'CapsLock') {
            return !this.state.isCapsLockOn;
        } else {
            return event.getModifierState('CapsLock');
        }
    }

    // tslint:disable-next-line:typedef (autogenerated)
    private detectInputLanguage(event): string {
        const langArray = [];

        langArray.push({
            langName: this.i18n('js.auth.pages.login.fields.input.language_shortcut_ru'),
            langRegexp: new RegExp(this.i18n('js.auth.pages.login.fields.input.language_regexp_ru'))
        });
        langArray.push({
            langName: this.i18n('js.auth.pages.login.fields.input.language_shortcut_en'),
            langRegexp: new RegExp(this.i18n('js.auth.pages.login.fields.input.language_regexp_en'))
        });

        // tslint:disable-next-line:typedef (autogenerated)
        this.detectInputLanguage = function(innerEvent) {
            if (innerEvent.key.length !== 1) {
                return;
            }

            for (const lang of langArray) {
                if (lang.langRegexp.test(innerEvent.key)) {
                    return lang.langName;
                }
            }
        };

        return this.detectInputLanguage(event);
    }

    // tslint:disable-next-line:member-access typedef (autogenerated)
    keyDownHandler(event) {
        const isCapsLockOn: boolean = this.isCapsLockOn(event);
        const inputLang: string = this.detectInputLanguage(event) || this.state.inputLang;

        this.setState({ isCapsLockOn, inputLang });
    }

    // tslint:disable-next-line:typedef member-access (autogenerated)
    render() {
        const styles = this.getStyles();

        return (
            <div key="login-input-output" style={styles.fieldOuter}>
                <label style={styles.label} htmlFor={this.props.formProps.id}>
                    {this.i18n(
                        'js.auth.pages.login.fields.' +
                            this.props.formProps.id.toLowerCase() +
                            '.label'
                    )}
                </label>
                <div style={styles.passwordContainer}>
                    <input
                        disabled={this.props.disabled}
                        id={this.props.formProps.id}
                        type={this.props.type ? this.props.type : 'text'}
                        style={styles.input}
                        {...this.prepareInputProps(this.props.formProps)}
                        onKeyDown={this.keyDownHandler}
                    />
                    <div style={styles.indicatorContainer}>
                        <Indicator
                            styleParams={this.props.styleParams}
                            isHidden={!this.state.isCapsLockOn}
                        >
                            {this.i18n('js.auth.pages.login.fields.input.caps_lock')}
                        </Indicator>
                        <Indicator
                            styleParams={this.props.styleParams}
                            isHidden={this.state.inputLang.length === 0}
                        >
                            {this.state.inputLang}
                        </Indicator>
                    </div>
                </div>
                <div key="error" style={styles.validationError}>
                    {this.props.formProps.validationErrorMessage}
                </div>
            </div>
        );
    }
}

// tslint:disable-next-line:no-default-export (autogenerated)
export default LoginPasswordInput;
